/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { AuthzEngines } from '@square/authz-engines';
const existingComponentInstances = new Map();
let EmberMultipassComponentsAuthzEnginesModalBaseComponent = (_class = class EmberMultipassComponentsAuthzEnginesModalBaseComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    /**
     * Flag only set to be true if the current instance is the first modal template rendered in the
     * document. This is used to prevent multiple modals from being displayed at the same time when
     * the component is imported to the DOM by different parts of the application.
     */
    _initializerDefineProperty(this, "firstRenderInDoc", _descriptor, this);
    _initializerDefineProperty(this, "view", _descriptor2, this);
    _initializerDefineProperty(this, "authzEnginesManager", _descriptor3, this);
    _defineProperty(this, "handleViewChange", event => {
      this.view = event.detail.view;
      this.authzEnginesManager = event.detail.authzEnginesManager;
    });
    _defineProperty(this, "handleWillDestroy", () => {
      this.authzEnginesManager?.reset();
    });
    _defineProperty(this, "handleModalClose", () => {
      this.authzEnginesManager?.closeModal();
    });
    _defineProperty(this, "handleVerifiedAndClose", () => {
      this.authzEnginesManager?.onVerified();
    });
    document.addEventListener(AuthzEngines.AUTHZ_ENGINES_VIEW_CHANGE_EVENT, this.handleViewChange);
    if (existingComponentInstances.size === 0) {
      this.firstRenderInDoc = true;
    }
    existingComponentInstances.set(this, this);
  }
  willDestroy() {
    super.willDestroy();
    document.removeEventListener(AuthzEngines.AUTHZ_ENGINES_VIEW_CHANGE_EVENT, this.handleViewChange);
    existingComponentInstances.delete(this);
    if (this.firstRenderInDoc && existingComponentInstances.size > 0) {
      // Active modal being removed, need to nominate the next active modal from inactive ones
      existingComponentInstances.values().next().value.firstRenderInDoc = true;
    }
  }
  get isTwoFactorEnrollView() {
    return this.view === AuthzEngines.ModalView.TWO_FACTOR_ENROLL;
  }
  get isTwoFactorUpgradeView() {
    return this.view === AuthzEngines.ModalView.TWO_FACTOR_UPGRADE;
  }
  get isTwoFactorScaView() {
    return this.view === AuthzEngines.ModalView.TWO_FACTOR_UPGRADE_SCA;
  }
  get twoFactorVerificationSource() {
    if (this.view === AuthzEngines.ModalView.TWO_FACTOR_UPGRADE_SCA) {
      return 'SCA_VERIFICATION';
    }
    return 'STEP_UP_AUTHENTICATION';
  }
  get recoveryReason() {
    return 'STEP_UP_AUTHENTICATION';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "firstRenderInDoc", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "view", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return AuthzEngines.ModalView.INACTIVE;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "authzEnginesManager", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);
export { EmberMultipassComponentsAuthzEnginesModalBaseComponent as default };